import useDefinedContext from "hooks/useDefinedContext";
import ChartTooltipCardContext from "../contexts/ChartTooltipCardContext";

function useChartTooltipCard() {
  return useDefinedContext(ChartTooltipCardContext);
}
export default useChartTooltipCard;
